import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';
import integrationBoxFragment from './integrationBoxFragment';
import integrationDropboxFragment from './integrationDropboxFragment';
import integrationGoogleDriveFragment from './integrationGoogleDriveFragment';
import integrationOneDriveFragment from './integrationOneDriveFragment';
import integrationMicrosoftTeamsFragment from './integrationMicrosoftTeamsFragment';
import integrationDesktopFragment from './integrationDesktopFragment';
import integrationSlackFragment from './integrationSlackFragment';

export const integrationFragment = gql`
  fragment integrationFragment on Integration {
    dokkioClass
    id
    accountID
    integrationType
    credentialID
    name
    description
    loadingStartedAt
    loadingFinishedAt
    messagesLoadingStartedAt
    messagesLoadingFinishedAt
    textLoadingFinishedAt
    textLoadingCount
    lastEmailSyncedSentAt
    deletedAt
    errorCode
    errorStatus
    errorMessage
    errorVariables
    errorUpdatedAt
    integrationItem {
      ...integrationItemFragment
    }
    integrationBox {
      ...integrationBoxFragment
    }
    integrationDropbox {
      ...integrationDropboxFragment
    }
    integrationGoogleDrive {
      ...integrationGoogleDriveFragment
    }
    integrationOneDrive {
      ...integrationOneDriveFragment
    }
    integrationMicrosoftTeams {
      ...integrationMicrosoftTeamsFragment
    }
    integrationDesktop {
      ...integrationDesktopFragment
    }
    integrationSlack {
      ...integrationSlackFragment
    }
  }
  ${integrationItemFragment}
  ${integrationBoxFragment}
  ${integrationDropboxFragment}
  ${integrationGoogleDriveFragment}
  ${integrationOneDriveFragment}
  ${integrationMicrosoftTeamsFragment}
  ${integrationDesktopFragment}
  ${integrationSlackFragment}
`;
export default integrationFragment;
